export const MAX_NUMBER_OF_ELEMENTS_IN_SYSTEM_BETTINGSLIP = 8;
